export default __webpack_public_path__ + "static/media/Nitroxgallery_18.1ca747dd.jpg";